import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { requestSportbookStart, requestSportbookEnd } from '../../store/sportbookLive/sportbookLive.thunks';
import { setUrlForSportbook } from '../../store/betbyWidget/urlForSportbook.slice';
import { requestSportPageEvent } from '../../store/sportPageEvent/sportPageEvent.thunks';
import { requestInplayPopular } from '../../store/inplayPopular/inplayPopular.thunks';
import { requestExchangeGamesAll } from '../../store/exchangeGamesAll/exchangeGamesAll.thunks'
import { requestLiveCasinoID } from '../../store/liveCasino/liveCasino.thunks';


export const connectExchangeGamesMobile = (wrappedProps) => (component) => {
  function mapStateToProps(state) {
    return {
      sportPageEvent: state.sportPageEvent,
      inplayPopular: state.inplayPopular,
      exchangeGamesAll: state.exchangeGamesAll,
      auth: state.auth,
      slotCasinoPopUp: state.slotCasinoPopUp,
    }
  }

  function mapDispatchToProps(dispatch) {
    const actions = {
      requestSportPageEvent,
      requestInplayPopular,
      requestExchangeGamesAll,
      requestLiveCasinoID
    }

    return { actions: bindActionCreators(actions, dispatch) }
  }

  return connect(mapStateToProps, mapDispatchToProps)(component)
}
